import API from "@/api/FilesAPI";
import API2 from "@/api/RegionStagesAPI";
// import API3 from "@/api/OrganizationAPI";
import {typeRequestNameForApi, idUserForApi, typesContact} from "@/controllers/UserController";
import store from "@/store";

class FilesController {
  constructor() {
    this.api = API;
    this.api2 = API2;
    // this.apiOrg = API3;
  }

  _checkTypeContact(typeContact) {
    if (!typesContact[typeContact])
      throw new Error(`type contact invalid can be founder or region; ${typeContact}`);
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  /**
   * @param {String} scanType
   * @param {String} description
   * @param {File} file
   * @param {String} specialEndpoint
   * */
  async saveFile(scanType = null, file = null, description = '') {
    console.log(scanType);
    try {
      if (description === '0') {
        description = '';
      }
      if (!scanType || !file)
        throw new Error('scanType && file invalid; cannot be null');
      let typeContact = typeRequestNameForApi();
      let id = idUserForApi();
      this._checkId(id);
      this._checkTypeContact(typeContact);
      const form = new FormData();
      form.append('file', file);
      if (scanType === 'EXCEL_MINKULT') {
        const res = await this.api2.saveExcelFile(form);
        return res.data
      } else if (scanType === 'EXCEL_FOUNDER_FILE') {
        const res = await this.api2.saveExcelFile2(form, id);
        return res.data
      } else {
        const res = await this.api.saveFile(form, scanType, description, `${typeContact}ID`, id);
        return res.data
      }
    } catch (e) {
      console.error('error saveFile ' + e.message)
      throw new Error('error saveFile ' + e.message)
    }
  }

  /**
   * @param {String} id
   * */
  async getFile(id = null) {
    try {
      if (!id)
        throw new Error('id invalid; cannot be null');
      const res = await this.api.getFile(id);
      return res.data
    } catch (e) {
      console.error('error getFile ' + e.message)
      throw new Error('error getFile ' + e.message)
    }
  }

  /**
   * @param {Integer} orgId
   * @param {Integer} prilNum
   * */
  async getPril(orgId, prilNum) {
    try {
      if (!orgId)
        throw new Error('orgId invalid; cannot be null');
      if (!prilNum)
        throw new Error('prilNum invalid; cannot be null');
      const res = await this.api.getPril(orgId, prilNum);
      return res.data
    } catch (e) {
      console.error('error getFile ' + e.message)
      throw new Error('error getFile ' + e.message)
    }
  }

  // async getReport(id) {
  //   try {
  //     // if (!path)
  //     //   throw new Error('path invalid; cannot be null');
  //     const res = await this.apiOrg.getOrgReport(id);
  //     return res.data
  //   } catch (e) {
  //     console.error('error getReport ' + e.message)
  //     throw new Error('error getReport ' + e.message)
  //   }
  // }

  /**
   * @param {String} id
   * */
  async deleteFile(id = null) {
    try {
      if (!id)
        throw new Error('id invalid; cannot be null');
      const res = await this.api.deleteFile(id);
      return res.data
    } catch (e) {
      console.error('error deleteFile ' + e.message)
      throw new Error('error deleteFile ' + e.message)
    }
  }

  /**
   * @param {'regionID' | 'founderID' | 'orgID' | null} [userType]
   * @param {String | null} [userId]
   * */
  async getFileList(userType, userId = null) {
    try {
      userType = userType ?? typeRequestNameForApi() + 'ID';
      userId = userId ?? idUserForApi(userId);
      this._checkId(userId);
      const res = await this.api.getFileList(userType, userId);
      return res.data
    } catch (e) {
      if (e.status >= 500)
        await store.dispatch('notifications/addNotification', {
          notificationStatus: 'error',
          notificationMessage: 'ошибка получения загруженный файлов  ',
          timeout: 3000
        }, {root: true});
      console.error(`error getFileList ${e.status}` + e.message)
      throw new Error('error getFileList ' + e.message)
    }
  }

}

export default new FilesController();